import { Location } from '../../types/models/Location.model'
import { getLocationParts, getSlug, getTitle } from '../location'
import transformTextToSlug from '../../utils/transformTextToSlug'
import { isNonEmptyString } from '@/utils/checks'
import { BreadCrumbs } from './computeBreadCrumbs'
import { BANNED_LOCATION_TITLES } from '../location/constants'

interface ComputeLocationBreadCrumbs {
  (props: { location: Location }): {
    breadCrumbs: BreadCrumbs
    selectedTitle: string
  }
}

const computeLocationBreadCrumbs: ComputeLocationBreadCrumbs = ({
  location
}): {
  breadCrumbs: BreadCrumbs
  selectedTitle: string
} => {
  const locationTitle = getTitle(location)

  const breadCrumbs = getLocationParts(location)
    .map((locationPart) => {
      const locationPartTitle = getTitle(locationPart as Location)
      const locationPartSlug = getSlug(locationPart as Location)
      return {
        title: locationPartTitle,
        slug: isNonEmptyString(locationPartSlug)
          ? `${locationPartSlug}`
          : `${transformTextToSlug(locationPartTitle)}`,
        type: locationPart?.type
      }
    })
    .filter((item) => !BANNED_LOCATION_TITLES.has(item.title))

  return {
    breadCrumbs,
    selectedTitle: locationTitle
  }
}

export default computeLocationBreadCrumbs
